import microtechMark from '../assets/microtech-cube.png';

/**
 * Micro Tech's credit line, mirroring the paper form: NHC owns the letterhead,
 * Micro Tech owns the IT implementation block.
 *
 * The mark is the real cube logo, pre-cropped to just the mark (no wordmark
 * baked in, which is set separately in text beside it), because the supplied logo
 * bakes its wordmark into a 499px square, which turns to mush at the sizes a
 * footer credit needs, but the cube crop alone holds up fine this small.
 */
export function MicroTechCredit({
  className = '',
  stacked = false,
}: {
  className?: string;
  /** Puts "IT services by" on its own line, for a narrow column, where the
   *  one-line form wraps into a ragged two. */
  stacked?: boolean;
}) {
  if (stacked) {
    return (
      <span className={`block ${className}`}>
        <span className="block text-slate-500 dark:text-slate-400">IT services by</span>
        <span className="mt-1 flex items-center gap-2">
          <img src={microtechMark} alt="" className="h-7 w-auto shrink-0" />
          <span className="font-medium whitespace-nowrap text-slate-600 dark:text-slate-300">
            Micro Tech Namibia
          </span>
        </span>
      </span>
    );
  }

  return (
    <span className={`flex items-center gap-2 ${className}`}>
      <span className="text-slate-500 dark:text-slate-400">IT services by</span>
      <img src={microtechMark} alt="" className="h-6 w-auto shrink-0" />
      <span className="font-medium text-slate-600 dark:text-slate-300">Micro Tech Namibia</span>
    </span>
  );
}
